export const Color = {
    StatusisGareshe: 'Red',
    Obieqti: 'Pink',
    Zegli: 'LPink',
    ErovnuliZegli: 'HPink',
    MsoflioZegli: 'Yellow',
}